module.exports = __webpack_public_path__ + "static/media/10.b7340a6e.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/galeria/10.jpeg
// module id = 156
// module chunks = 0